export class NoteFilter {
    entityType: string;
	entityId: number;
}